import { jwtDecode } from 'jwt-decode';

export function decodeJwt(token: string) {
  return jwtDecode(token);
}

export function checkIsTokenExpired(token: string): boolean {
  const decoded = decodeJwt(token);
  const currentTime = Math.floor(Date.now() / 1000);

  if (!decoded.exp) {
    console.warn('Missing "exp" field in JWT payload.');
    return true;
  }

  if (currentTime > decoded.exp) {
    console.warn('Token has expired.');
    return true;
  }

  return false;
}
